<template>
  <alt-prorated-today>
    <todays-total v-if="!isCurrentMode">
      <h3 class="opc-cart__submit__label--left">{{ submitLabel }}</h3>
      <h3 class="opc-cart__submit__label--right">
        <!-- // FREE TRIAL  -->
        <span v-if="isFreeTrialCharge">
          {{ this.$money(0) }}
        </span>
        <i v-else-if="isLoadingTax || isLoadingPreview" class="zm-icon-loading" />
        <!-- // FREE TRIAL - showProratedCharge won't be shown at the same time with Free Trial price -->
        <span v-else-if='showProratedCharge'>
          {{ this.proratedChargeTotalAmountText }}
        </span>
        <span v-else>
          <v-amount-loading>{{ this.$money(includeTaxTotalAmount) }}</v-amount-loading>
          <p class="opc-cart__total__text__sub text-no-capitalize" v-if="showPlusTaxTxt">
            <priceVATTip />
            <span v-if="!showVATTip" class="opc-cart__total__tax-tip">{{
              $t('billing.order_summary.plus_applicable_taxes') }}</span>
          </p>
        </span>
      </h3>
    </todays-total>
  </alt-prorated-today>
</template>

<script>
import { mapGetters } from 'vuex';

import AltProratedToday from '@/views/config/shopping-cart/prorated/today.vue';
import TodaysTotal from '@/views/config/shopping-cart/todays-total.vue';
import VAmountLoading from '@/components/v-amount-loading.vue';

import nextMixin from './nextMixin';
import flow from '@/flows';
import { VIEWS } from '@/common/constants.js';

export default {
  name: 'AltTodaysTotal',
  mixins: [nextMixin],
  components: {
    AltProratedToday,
    TodaysTotal,
    VAmountLoading,
  },
  computed: {
    ...mapGetters([
      'isSelectedSameAsEditablePlansInBought',
      'fromCampaignLink',
      'haveVerifiedSupportCoupon',
      'isInrCitEligible',
      'isProratedChargeAmountCalculated',
      'mixBuyFlowContainsEditCase',
      'getSelectedPlans',
      'isLoadingTax',
      'isLoadingPreview',
      'getProratedChargeTotalAmount',
      'includeTaxTotalAmount',
      'getTaxTotalAmount',
      'getTotalCharge',
      'isTaxEstimatedBefore',
      'addressInfo',
    ]),
    isCurrentMode() {
      // display as current plans mode or updated mode
      return this.isSelectedSameAsEditablePlansInBought && !this.fromCampaignLink && !this.haveVerifiedSupportCoupon;
    },
    showProratedCharge() {
      if (this.$context.is.delta) return true;
      return this.isInrCitEligible && this.isProratedChargeAmountCalculated;
    },
    submitLabel(){
      if (this.showProratedCharge) {
        return this.$t('billing.order_summary.todays_total');
      }
      if(this.$context.is.pro2biz || this.$context.is.edit || this.mixBuyFlowContainsEditCase || this.$context.is.add2cart || this.migratePlanState.is.upgrade || this.migratePlanState.is.downgrade || this.$context.is.zs2ze) return this.mx_upgrade_nextChargeLabel;
      return this.$t('billing.order_summary.todays_total');
    },
    isFreeTrialCharge() {
      return this.getSelectedPlans.every(plan => !!plan.isOnlineFreeTrial); // ? some or every or is flow
    },
    showPlusTaxTxt(){
      const is0total = ( this.getTotalCharge + this.getTaxTotalAmount === 0 )
      return !(this.isShowTax && this.isTaxEstimatedBefore) && !is0total
    },
    isFreeTrialFlow() {
      return this.$context.is.add2trial || this.$context.is.buyTrial;
    },
    isShowTax() {
      // FREE TRIAL - won't show tax fee for free trial, except it's under FCCA compliance
      if (this.isFreeTrialFlow && this.addressInfo.country !== 'DE') {
        return false;
      }
      // isTaxExempt in zuora account is only part of the whole tax amount
      if (flow.view() === VIEWS.COMPOUND) {
        return true;
      }
      if (this.$context.is.configPage) {
        if (this.isTaxEstimatedBefore) return true;
        return false;
      }
      return true;
    },
    proratedChargeTotalAmountText() {
      return this.$money(Math.max(this.getProratedChargeTotalAmount, 0));
    },
  }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>
